import React, { ReactNode } from 'react';
import { Accordion } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import AccordionItem from './AccordionItem';
import ResendEmailPanel from './ResendEmailPanel';
import VerifiedOnMobileInstructions from './VerifiedOnMobileInstructions';
import WrongEmailInstructions from './WrongEmailInstructions';

interface CommonProblemItem {
    problem: string;
    solution: NonNullable<ReactNode>;
}

const commonProblems: Array<CommonProblemItem> = [
    {
        problem: UIStrings.IHaveNotReceivedTheEmail,
        solution: <ResendEmailPanel />,
    },
    {
        problem: UIStrings.IHaveUsedWrongEmailToSignup,
        solution: <WrongEmailInstructions />,
    },
    {
        problem: UIStrings.IHaveVerifiedOnMobile,
        solution: <VerifiedOnMobileInstructions />,
    },
];

function AccordionPanel(): React.JSX.Element {
    return (
        <div className="px-5 pt-[35px] pb-5">
            <p className="text-foreground mx-2.5 mb-2 text-sm font-bold">{UIStrings.HavingIssues}</p>
            <Accordion type="single" collapsible className="w-full">
                {commonProblems.map((item, index) => (
                    <AccordionItem key={item.problem} value={`item-${index}`} header={item.problem}>
                        {item.solution}
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}

export default AccordionPanel;
